import { createFileRoute, Link } from '@tanstack/react-router';

import { Button } from '@/components/ui/button';
import { adminHead } from '@/lib/seo';
import { signOutFn } from '@/server/functions/auth';

export const Route = createFileRoute('/_admin/admin/forbidden')({
    component: ForbiddenPage,
    head: () => adminHead('נדרשת הרשאת ניהול', '/admin/forbidden'),
});

function ForbiddenPage() {
    return (
        <div
            dir="rtl"
            lang="he"
            className="flex min-h-screen flex-col items-center justify-center gap-4 bg-black px-6 text-center text-[#ededed]"
        >
            <p className="text-[10px] text-white/55">אין גישה</p>
            <h1 className="text-2xl font-semibold tracking-tight">
                נדרשת הרשאת ניהול
            </h1>
            <p className="max-w-md text-sm text-white/50">
                החשבון מחובר, אך אינו חבר בצוות המנהלים. בקשו ממנהל קיים להוסיף
                אתכם בקונסולת הניהול ונסו שוב.
            </p>
            <div className="mt-2 flex gap-2">
                <Button
                    variant="outline"
                    className="rounded-none"
                    onClick={() => {
                        void signOutFn();
                    }}
                >
                    התנתקות
                </Button>
                <Button asChild className="rounded-none">
                    <Link to="/">חזרה לאתר</Link>
                </Button>
            </div>
        </div>
    );
}
